import React from "react"
import ReduxThunk from "redux-thunk"
import { Map } from "immutable"
import { combineReducers } from "redux-immutable"
import { createStore, applyMiddleware, compose } from "redux"
import { Provider } from "react-redux"
import AppRoot from "./AppRoot"
import reducers from "../redux/reducers"

class App extends React.Component {
	render() {
		const store = createStore(
			combineReducers({
				...reducers,
			}),
			Map(),
			compose(
				applyMiddleware(ReduxThunk),
				(typeof window.__REDUX_DEVTOOLS_EXTENSION__ !== "undefined") ? window.__REDUX_DEVTOOLS_EXTENSION__() : f => f,
			)
		)
		return (
			<Provider store={store}>
				<AppRoot />
			</Provider>
		)
	}
}

export default App



// WEBPACK FOOTER //
// ./src/conponents/App.js